import styled from 'styled-components';

export const CopyWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  gap: 10px;
`;

export const TextWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  gap: 5px;
  color: ${({ theme }) => theme.neutral_500};
`;

export const CopyButtonWrapper = styled.div`
  &:hover {
    & + ${TextWrapper} {
      border-radius: 2px;
      background-color: ${({ theme }) => theme.neutral_200};
      box-shadow: 0 0 0 4px ${({ theme }) => theme.neutral_200};
    }
  }
`;
